import { FC, PropsWithChildren, useEffect, useState } from 'react'
import { QueryClientProvider } from '@tanstack/react-query'

import { queryClient } from 'lib/queryClient'
import { ErrorModal } from 'containers/ErrorModal'
import { RequestError } from 'lib/apiClient'

export const ReactQueryProvider: FC<PropsWithChildren> = props => {
  const [errorMessage, setErrorMessage] = useState<string>()
  const [hasError, setHasError] = useState(false)

  useEffect(
    () =>
      queryClient.getMutationCache().subscribe(event => {
        if (
          event.type === 'updated' &&
          event.action.type === 'error' &&
          event.action.error instanceof RequestError
        ) {
          setErrorMessage(event.action.error.message)
          setHasError(true)
        }
      }),
    [],
  )

  return (
    <QueryClientProvider client={queryClient}>
      {props.children}
      <ErrorModal
        open={hasError}
        onClose={() => setHasError(false)}
        description={errorMessage}
      />
    </QueryClientProvider>
  )
}
